import { isNullOrUndefined } from 'src/app/helpers/tools';
import {TokenContent} from "src/app/layouts/public/login/models/tokenContent";

export class JWTHelper {
    public static decodeJwt(token: string) {
        if (isNullOrUndefined(token)) {
            return new TokenContent();
        }

        const tokenPayload: TokenContent = JSON.parse(atob(token.split('.')[1]));

        if (tokenPayload) {
            // for >= .NET 6 unique_name is not populated, it is in name so copy across
            if (tokenPayload.unique_name == null || tokenPayload.unique_name == undefined) {
                tokenPayload.unique_name = tokenPayload.name;
            }
        }

        return tokenPayload;
    }
}